import { Injectable } from "@angular/core";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";
import { PlusdCommonService } from "./plusd-common.service";

@Injectable({
  providedIn: "root"
})

export class SolicitudService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
  ) { }

 /* inicializar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/inicializar",
      parametro
    );
  }

  obtenerAdministrado(parametro): any {
    parametro.idSesion = '0';
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/obtener-administrado",
      parametro
    );
  }

  listar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/listar",
      parametro
    );
  }

  listarContacto(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/contacto/listar",
      parametro
    );
  }

  listarSubsector(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/listar-subsector",
      parametro
    );
  }

  listarProvincia(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/listar-provincia",
      parametro
    );
  }

  listarDistrito(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/listar-distrito",
      parametro
    );
  }

  consultar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/consultar",
      parametro
    );
  }

  agregar(parametro): any {
    parametro.audCreadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/agregar",
      parametro
    );
  }

  modificar(parametro): any {
    parametro.audModificadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/modificar",
      parametro
    );
  }

  eliminar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/eliminar",
      parametro
    );
  }

  // Detalle
  inicializarContacto(parametro): any {
    parametro.audCreadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/listar-detalle",
      parametro
    );
  }

  consultarContacto(parametro): any {
    parametro.audCreadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/consultar-detalle",
      parametro
    );
  }

  agregarDetalle(parametro): any {
    parametro.audCreadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/agregar-detalle",
      parametro
    );
  }

  modificarDetalle(parametro): any {
    parametro.audModificadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/modificar-detalle",
      parametro
    );
  }

  listarCasillas(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitudsiged/obtener-casillas",
      parametro
    );
  }

  ingresoCasilla(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitudsiged/ingreso-casilla",
      parametro
    );
  }

  agregarVerificacion(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/agregar-verificacion",
      parametro
    );
  }

  verificar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/verificar",
      parametro
    );
  }

  enviarSms(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/enviar-sms",
      parametro
    );
  }

  usuarioExistente(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/consultar-usuario-existente",
      parametro
    );
  }*/
}
